var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('table', {
    staticClass: "table w-100"
  }, [_vm._m(0), _c('tbody', [_c('tr', [_vm.claimList.records.length < 1 ? _c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v(" No records found. ")]) : _vm._e()]), _vm._l(_vm.claimList.records, function (claim, index) {
    var _claim$status, _claim$status2, _claim$status3;

    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(claim.plan_overview.plan_name))]), _c('td', [_c('strong', [_vm._v(_vm._s(claim.user_info_policy_address.member_name) + " " + _vm._s(claim.user_info_policy_address.member_lname))]), _c('br'), _c('span', {
      staticClass: "claim-email"
    }, [_vm._v(" " + _vm._s(claim.user_info_policy_address.member_email) + " "), _c('b-badge', {
      style: {
        backgroundColor: _vm.statusClass(claim === null || claim === void 0 ? void 0 : claim.email_delivery_status)
      },
      attrs: {
        "pill": ""
      }
    }, [_vm._v(" " + _vm._s(claim !== null && claim !== void 0 && claim.email_delivery_status ? claim.email_delivery_status : "N/A") + " ")])], 1)]), _c('td', [_c('strong', [_vm._v("Added: ")]), _vm._v(" " + _vm._s(_vm.formatDate(claim.created_at)) + " "), _c('br'), claim.submitted_at ? _c('span', [_c('strong', [_vm._v("Submitted: ")]), _vm._v(" " + _vm._s(_vm.formatDate(claim.submitted_at)) + " ")]) : _vm._e()]), _c('td', [_c('div', [_c('strong', [_vm._v("Created:")]), claim.claim_by_type.toLowerCase() === 'rep' ? _c('span', [_vm._v(" " + _vm._s(claim.claim_by_type) + " (" + _vm._s(claim.claim_by_rep_name) + ") ")]) : _c('span', [_vm._v(" " + _vm._s(claim.claim_by_type) + " ")])]), claim.submitted_by ? _c('div', [_c('strong', [_vm._v("Submitted:")]), claim.submitted_by.toLowerCase() === 'rep' ? _c('span', [_vm._v(" " + _vm._s(claim.submitted_by) + " (" + _vm._s(claim.submitted_by_rep_name) + ") ")]) : _c('span', [_vm._v(" " + _vm._s(claim.submitted_by || "-") + " ")])]) : _vm._e()]), _c('td', {
      class: claim === null || claim === void 0 ? void 0 : (_claim$status = claim.status) === null || _claim$status === void 0 ? void 0 : _claim$status.toLowerCase()
    }, [_c('span', [_vm._v(_vm._s((claim === null || claim === void 0 ? void 0 : (_claim$status2 = claim.status) === null || _claim$status2 === void 0 ? void 0 : _claim$status2.charAt(0).toUpperCase()) + (claim === null || claim === void 0 ? void 0 : (_claim$status3 = claim.status) === null || _claim$status3 === void 0 ? void 0 : _claim$status3.slice(1))))])]), _c('td', {
      staticClass: "d-flex align-items-center action-icons"
    }, [claim.status.toLowerCase() === 'submitted' || claim.status.toLowerCase() !== 'submitted' ? _c('custom-button', {
      attrs: {
        "title": claim.status.toLowerCase() === 'submitted' ? 'View File' : 'Edit File',
        "iconClass": "fas fa-eye"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.onViewFile(claim);
        }
      }
    }) : _vm._e(), claim.status.toLowerCase() === 'pending' ? _c('custom-button', {
      attrs: {
        "title": "Submit File",
        "iconClass": "fas fa-file-upload"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.onSubmitFile(claim);
        }
      }
    }) : _vm._e()], 1)]);
  })], 2)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Plan")]), _c('th', [_vm._v("Member Details")]), _c('th', [_vm._v("Date")]), _c('th', [_vm._v("Created/Submitted By")]), _c('th', [_vm._v("Claim Status")]), _c('th', [_vm._v("Action")])])]);
}]

export { render, staticRenderFns }